<template>
  <ancestryline-modal title="forms.client.title" :id="'modal-client-form-'+id" :close="true" @close="close" :loading="false">
    <ClientForm :show-header="false" :client-id="clientId" :key="id" :modal-id="id"/>
  </ancestryline-modal>
</template>

<script>
import DialogService from "@/business/ModalBusiness";
import EventBus from "@/commons/EventBus";
import Utils from "@/utils/Utils";

export default {
  name: "ModalClientForm",
  components: {
    ClientForm: () => import("@/viewer/client/ClientForm"),
  },

  props: ["clientId"],

  mounted() {
    EventBus.$on('client_saved_'+this.id, this.saved);
  },

  data(){
    return {
      id: Utils.uuid(),
    }
  },

  methods:{

    close(){
      DialogService.closeModal();
    },

    saved(client){
      DialogService.closeModal(client);
    },

  },

  destroyed() {
    EventBus.$off('client_saved_'+this.id);
  }

}
</script>

<style scoped>

</style>